"use client";

import Link from "next/link";
import Image from "next/image";
import { useState, useEffect } from "react";
import {
  ArrowRight,
  Search,
  Clock,
  ChevronLeft,
  ChevronRight,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Badge } from "@/components/ui/badge";
import { ScrollReveal } from "@/components/scroll-reveal";

// Danh sách các bài viết mẫu
const BLOG_POSTS = [
  {
    id: 1,
    title: "5 cách tăng doanh thu cho spa của bạn trong mùa thấp điểm",
    excerpt:
      "Khám phá các chiến lược hiệu quả giúp duy trì và tăng doanh thu cho spa của bạn ngay cả trong những tháng thấp điểm của năm.",
    date: "12 Tháng 4, 2025",
    category: "Quản lý",
    slug: "5-cach-tang-doanh-thu-spa",
    image: "/placeholder.svg?height=200&width=400&text=Spa+Management",
  },
  {
    id: 2,
    title: "Cách nâng cao trải nghiệm khách hàng tại spa với công nghệ",
    excerpt:
      "Tìm hiểu cách sử dụng công nghệ để cải thiện trải nghiệm khách hàng, từ đặt lịch trực tuyến đến các chương trình khách hàng thân thiết.",
    date: "8 Tháng 4, 2025",
    category: "Khách hàng",
    slug: "trai-nghiem-khach-hang",
    image: "/placeholder.svg?height=200&width=400&text=Customer+Experience",
  },
  {
    id: 3,
    title: "10 kỹ năng cần thiết cho nhân viên spa chuyên nghiệp",
    excerpt:
      "Khám phá các kỹ năng quan trọng mà mỗi nhân viên spa cần có để cung cấp dịch vụ xuất sắc và xây dựng mối quan hệ lâu dài với khách hàng.",
    date: "2 Tháng 4, 2025",
    category: "Đào tạo",
    slug: "dao-tao-nhan-vien",
    image: "/placeholder.svg?height=200&width=400&text=Staff+Training",
  },
  {
    id: 4,
    title: "Xu hướng làm đẹp và spa hàng đầu năm 2025",
    excerpt:
      "Cập nhật những xu hướng mới nhất trong ngành làm đẹp và spa để giúp doanh nghiệp của bạn luôn đi đầu và thu hút khách hàng mới.",
    date: "28 Tháng 3, 2025",
    category: "Xu hướng",
    slug: "xu-huong-lam-dep-2025",
    image: "/placeholder.svg?height=200&width=400&text=Beauty+Trends",
  },
  {
    id: 5,
    title: "Cách tối ưu hóa quy trình đặt lịch cho spa của bạn",
    excerpt:
      "Tìm hiểu các phương pháp hiệu quả để tối ưu hóa quy trình đặt lịch, giảm thời gian chờ đợi và tăng sự hài lòng của khách hàng.",
    date: "20 Tháng 3, 2025",
    category: "Quy trình",
    slug: "toi-uu-hoa-quy-trinh-dat-lich",
    image: "/placeholder.svg?height=200&width=400&text=Booking+Process",
  },
  {
    id: 6,
    title: "Chiến lược marketing hiệu quả cho spa trong thời đại số",
    excerpt:
      "Khám phá các chiến lược marketing số hiệu quả giúp spa của bạn tiếp cận nhiều khách hàng tiềm năng và xây dựng thương hiệu mạnh mẽ.",
    date: "15 Tháng 3, 2025",
    category: "Marketing",
    slug: "chien-luoc-marketing-spa",
    image: "/placeholder.svg?height=200&width=400&text=Digital+Marketing",
  },
  {
    id: 7,
    title: "Cách chọn và quản lý sản phẩm cho spa của bạn",
    excerpt:
      "Hướng dẫn chi tiết về cách lựa chọn, quản lý và tối ưu hóa danh mục sản phẩm để tăng doanh thu và đáp ứng nhu cầu của khách hàng.",
    date: "10 Tháng 3, 2025",
    category: "Sản phẩm",
    slug: "quan-ly-san-pham-spa",
    image: "/placeholder.svg?height=200&width=400&text=Product+Management",
  },
  {
    id: 8,
    title: "Thiết kế không gian spa: Tạo trải nghiệm thư giãn tối ưu",
    excerpt:
      "Tìm hiểu cách thiết kế không gian spa để tạo ra môi trường thư giãn, sang trọng và mang lại trải nghiệm tuyệt vời cho khách hàng.",
    date: "5 Tháng 3, 2025",
    category: "Thiết kế",
    slug: "thiet-ke-khong-gian-spa",
    image: "/placeholder.svg?height=200&width=400&text=Spa+Design",
  },
  {
    id: 9,
    title: "Cách xây dựng và duy trì đội ngũ nhân viên spa xuất sắc",
    excerpt:
      "Chiến lược tuyển dụng, đào tạo và giữ chân nhân viên tài năng để xây dựng đội ngũ chuyên nghiệp và tận tâm với khách hàng.",
    date: "28 Tháng 2, 2025",
    category: "Nhân sự",
    slug: "xay-dung-doi-ngu-nhan-vien",
    image: "/placeholder.svg?height=200&width=400&text=Team+Building",
  },
  {
    id: 10,
    title: "Phần mềm quản lý spa: So sánh các giải pháp hàng đầu năm 2025",
    excerpt:
      "Đánh giá chi tiết về các phần mềm quản lý spa tốt nhất trên thị trường, giúp bạn lựa chọn giải pháp phù hợp nhất cho doanh nghiệp.",
    date: "20 Tháng 2, 2025",
    category: "Công nghệ",
    slug: "so-sanh-phan-mem-quan-ly-spa",
    image: "/placeholder.svg?height=200&width=400&text=Spa+Software",
  },
];

// Danh sách các danh mục
const CATEGORIES = [
  "Tất cả",
  "Quản lý",
  "Khách hàng",
  "Đào tạo",
  "Xu hướng",
  "Marketing",
  "Công nghệ",
  "Thiết kế",
  "Nhân sự",
  "Sản phẩm",
  "Quy trình",
];

export default function BlogPage() {
  const [mounted, setMounted] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("Tất cả");
  const [currentPage, setCurrentPage] = useState(1);
  const postsPerPage = 9;

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return null;
  }

  // Lọc bài viết theo tìm kiếm và danh mục
  const filteredPosts = BLOG_POSTS.filter((post) => {
    const matchesSearch =
      post.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.excerpt.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory =
      selectedCategory === "Tất cả" || post.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  // Phân trang
  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = filteredPosts.slice(indexOfFirstPost, indexOfLastPost);
  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1">
        {/* Hero Section */}
        <section className="w-full py-12 md:py-16 bg-gradient-to-r from-indigo-50 to-purple-50 overflow-hidden">
          <div className="container px-4 md:px-6 relative">
            <div className="absolute top-0 left-0 w-72 h-72 bg-indigo-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float"></div>
            <div
              className="absolute bottom-0 right-0 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-float"
              style={{ animationDelay: "2s" }}
            ></div>

            <div className="max-w-4xl mx-auto text-center relative z-10">
              <ScrollReveal>
                <h1 className="text-3xl font-bold tracking-tighter sm:text-5xl md:text-6xl/none bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 to-purple-500">
                  Blog
                </h1>
                <p className="mt-4 text-muted-foreground md:text-xl max-w-3xl mx-auto">
                  Khám phá các bài viết, hướng dẫn và tin tức mới nhất về quản
                  lý doanh nghiệp và phát triển kinh doanh
                </p>
              </ScrollReveal>

              <div className="mt-8 max-w-xl mx-auto">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                  <Input
                    type="text"
                    placeholder="Tìm kiếm bài viết..."
                    className="pl-10 py-6 rounded-full border-indigo-100 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 bg-white"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setCurrentPage(1);
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Categories */}
        <section className="w-full py-8 border-b border-gray-100">
          <div className="container px-4 md:px-6">
            <div className="flex flex-wrap gap-2 justify-center">
              {CATEGORIES.map((category) => (
                <Button
                  key={category}
                  variant={
                    selectedCategory === category ? "default" : "outline"
                  }
                  className={
                    selectedCategory === category
                      ? "bg-indigo-500 hover:bg-indigo-600 text-white"
                      : "border-indigo-100 hover:border-indigo-300 hover:bg-indigo-50"
                  }
                  onClick={() => {
                    setSelectedCategory(category);
                    setCurrentPage(1);
                  }}
                >
                  {category}
                </Button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Posts */}
        <section className="w-full py-12 md:py-16">
          <div className="container px-4 md:px-6">
            {currentPosts.length > 0 ? (
              <>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                  {currentPosts.map((post) => (
                    <ScrollReveal
                      key={post.id}
                      direction="up"
                      delay={0.1 * (post.id % 3)}
                    >
                      <div className="bg-white rounded-2xl border border-indigo-100 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1 overflow-hidden h-full flex flex-col">
                        <div className="relative h-48 overflow-hidden">
                          <Image
                            src={post.image || "/placeholder.svg"}
                            width={400}
                            height={200}
                            alt={post.title}
                            className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
                          />
                          <div className="absolute top-4 left-4">
                            <Badge
                              className={`${
                                post.category === "Quản lý"
                                  ? "bg-indigo-500 hover:bg-indigo-600"
                                  : post.category === "Khách hàng"
                                    ? "bg-purple-500 hover:bg-purple-600"
                                    : post.category === "Đào tạo"
                                      ? "bg-pink-500 hover:bg-pink-600"
                                      : post.category === "Xu hướng"
                                        ? "bg-blue-500 hover:bg-blue-600"
                                        : post.category === "Marketing"
                                          ? "bg-green-500 hover:bg-green-600"
                                          : post.category === "Công nghệ"
                                            ? "bg-cyan-500 hover:bg-cyan-600"
                                            : post.category === "Thiết kế"
                                              ? "bg-amber-500 hover:bg-amber-600"
                                              : post.category === "Nhân sự"
                                                ? "bg-red-500 hover:bg-red-600"
                                                : post.category === "Sản phẩm"
                                                  ? "bg-emerald-500 hover:bg-emerald-600"
                                                  : "bg-gray-500 hover:bg-gray-600"
                              }`}
                            >
                              {post.category}
                            </Badge>
                          </div>
                        </div>
                        <div className="p-6 flex-grow flex flex-col">
                          <div className="flex items-center  text-muted-foreground mb-3">
                            <Clock className="h-4 w-4 mr-1" />
                            <span>{post.date}</span>
                          </div>
                          <h3 className="text-xl font-bold mb-2 line-clamp-2 hover:text-indigo-600 transition-colors flex-grow">
                            <Link href={`/blog/${post.slug}`}>
                              {post.title}
                            </Link>
                          </h3>
                          <p className="text-muted-foreground mb-4 line-clamp-3">
                            {post.excerpt}
                          </p>
                          <Link
                            href={`/blog/${post.slug}`}
                            className="inline-flex items-center text-indigo-600 hover:text-indigo-700 font-medium mt-auto"
                          >
                            Đọc tiếp
                            <ArrowRight className="ml-1 h-4 w-4" />
                          </Link>
                        </div>
                      </div>
                    </ScrollReveal>
                  ))}
                </div>

                {/* Pagination */}
                {totalPages > 1 && (
                  <div className="flex justify-center mt-12">
                    <div className="flex items-center space-x-2">
                      <Button
                        variant="outline"
                        size="icon"
                        onClick={() =>
                          setCurrentPage((prev) => Math.max(prev - 1, 1))
                        }
                        disabled={currentPage === 1}
                        className="border-indigo-100 hover:border-indigo-300 hover:bg-indigo-50"
                      >
                        <ChevronLeft className="h-4 w-4" />
                      </Button>
                      {Array.from({ length: totalPages }, (_, i) => i + 1).map(
                        (page) => (
                          <Button
                            key={page}
                            variant={
                              currentPage === page ? "default" : "outline"
                            }
                            className={
                              currentPage === page
                                ? "bg-indigo-500 hover:bg-indigo-600 text-white"
                                : "border-indigo-100 hover:border-indigo-300 hover:bg-indigo-50"
                            }
                            onClick={() => setCurrentPage(page)}
                          >
                            {page}
                          </Button>
                        )
                      )}
                      <Button
                        variant="outline"
                        size="icon"
                        onClick={() =>
                          setCurrentPage((prev) =>
                            Math.min(prev + 1, totalPages)
                          )
                        }
                        disabled={currentPage === totalPages}
                        className="border-indigo-100 hover:border-indigo-300 hover:bg-indigo-50"
                      >
                        <ChevronRight className="h-4 w-4" />
                      </Button>
                    </div>
                  </div>
                )}
              </>
            ) : (
              <div className="text-center py-12">
                <div className="mb-4 text-indigo-500">
                  <Search className="h-12 w-12 mx-auto" />
                </div>
                <h3 className="text-xl font-bold mb-2">
                  Không tìm thấy bài viết nào
                </h3>
                <p className="text-muted-foreground mb-6">
                  Không có bài viết nào phù hợp với tìm kiếm của bạn. Vui lòng
                  thử lại với từ khóa khác.
                </p>
                <Button
                  className="bg-indigo-500 hover:bg-indigo-600 text-white"
                  onClick={() => {
                    setSearchTerm("");
                    setSelectedCategory("Tất cả");
                    setCurrentPage(1);
                  }}
                >
                  Xem tất cả bài viết
                </Button>
              </div>
            )}
          </div>
        </section>

        {/* Newsletter */}
        <section className="w-full py-12 md:py-16 bg-gradient-to-r from-indigo-50 to-purple-50">
          <div className="container px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <ScrollReveal>
                <h2 className="text-2xl font-bold tracking-tighter md:text-3xl/tight bg-clip-text text-transparent bg-gradient-to-r from-indigo-500 to-purple-500">
                  Đăng ký nhận bản tin
                </h2>
                <p className="mt-4 text-muted-foreground">
                  Nhận các bài viết, tin tức và cập nhật mới nhất về quản lý
                  doanh nghiệp trực tiếp vào hộp thư của bạn
                </p>
              </ScrollReveal>

              <div className="mt-6 flex flex-col sm:flex-row gap-2 max-w-md mx-auto">
                <Input
                  type="email"
                  placeholder="Email của bạn"
                  className="rounded-full border-indigo-100 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 bg-white"
                />
                <Button className="bg-indigo-500 hover:bg-indigo-600 text-white rounded-full px-6">
                  Đăng ký
                </Button>
              </div>
              <p className="mt-3  text-muted-foreground">
                Chúng tôi tôn trọng quyền riêng tư của bạn. Bạn có thể hủy đăng
                ký bất cứ lúc nào.
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
